export default __webpack_public_path__ + "static/media/48px_visa 1.62496702.svg";